(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image-slider"] && !Shopify.designMode) return;
  try {
    (() => {
    const elementName = 'vfl-image-slider';

    if (customElements.get(elementName)) return;

    class VflImageSlider extends HTMLElement {
      connectedCallback() {
        this.destroy();

        this.abortController = new AbortController();
        this.signal = this.abortController.signal;
        this.track = this.querySelector('[data-vfl-track]');
        this.viewport = this.querySelector('[data-vfl-viewport]');
        this.previousButton = this.querySelector(
          '[data-vfl-previous]'
        );
        this.nextButton = this.querySelector('[data-vfl-next]');
        this.dotsContainer = this.querySelector('[data-vfl-dots]');
        this.status = this.querySelector('[data-vfl-status]');

        this.slides = this.track
          ? Array.from(this.track.children).filter((child) =>
              child.matches('[data-vfl-slide]')
            )
          : [];

        this.currentIndex = Math.min(
          this.currentIndex || 0,
          Math.max(this.slides.length - 1, 0)
        );

        this.autoplayEnabled =
          this.dataset.autoplay === 'true';

        this.autoplayDelay = Math.max(
          Number(this.dataset.autoplayDelay) || 5000,
          1000
        );

        this.loopEnabled = this.dataset.loop === 'true';

        this.pauseOnHover =
          this.dataset.pauseOnHover === 'true';

        this.reducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        this.editorPaused = false;
        this.pointerStartX = null;

        this.classList.toggle(
          'is-single',
          this.slides.length <= 1
        );

        this.prepareSlides();
        this.buildDots();
        this.bindEvents();

        this.showSlide(this.currentIndex, {
          announce: false,
          restart: false
        });

        this.classList.add('is-ready');
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.destroy();
      }

      destroy() {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;

        if (this.abortController) {
          this.abortController.abort();
        }
      }

      prepareSlides() {
        const count = this.slides.length;

        this.slides.forEach((slide, index) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute(
            'aria-roledescription',
            'slide'
          );
          slide.setAttribute(
            'aria-label',
            `${index + 1} of ${count}`
          );
        });
      }

      buildDots() {
        if (!this.dotsContainer) return;

        this.dotsContainer.replaceChildren();

        this.slides.forEach((slide, index) => {
          const dot = document.createElement('button');

          dot.type = 'button';
          dot.className = 'vfl-image-slider__dot';
          dot.setAttribute(
            'aria-label',
            `Go to slide ${index + 1}`
          );

          dot.addEventListener(
            'click',
            () =>
              this.showSlide(index, {
                announce: true,
                restart: true
              }),
            { signal: this.signal }
          );

          this.dotsContainer.append(dot);
        });

        this.dots = Array.from(
          this.dotsContainer.children
        );
      }

      bindEvents() {
        this.previousButton?.addEventListener(
          'click',
          () =>
            this.previous({
              announce: true,
              restart: true
            }),
          { signal: this.signal }
        );

        this.nextButton?.addEventListener(
          'click',
          () =>
            this.next({
              announce: true,
              restart: true
            }),
          { signal: this.signal }
        );

        this.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();

              this.previous({
                announce: true,
                restart: true
              });
            }

            if (event.key === 'ArrowRight') {
              event.preventDefault();

              this.next({
                announce: true,
                restart: true
              });
            }
          },
          { signal: this.signal }
        );

        if (this.pauseOnHover) {
          this.addEventListener(
            'mouseenter',
            () => this.stopAutoplay(),
            { signal: this.signal }
          );

          this.addEventListener(
            'mouseleave',
            () => this.startAutoplay(),
            { signal: this.signal }
          );
        }

        this.addEventListener(
          'focusin',
          () => this.stopAutoplay(),
          { signal: this.signal }
        );

        this.addEventListener(
          'focusout',
          (event) => {
            if (!this.contains(event.relatedTarget)) {
              this.startAutoplay();
            }
          },
          { signal: this.signal }
        );

        this.viewport?.addEventListener(
          'pointerdown',
          (event) => {
            if (event.pointerType === 'mouse') return;

            this.pointerStartX = event.clientX;
          },
          { signal: this.signal }
        );

        this.viewport?.addEventListener(
          'pointerup',
          (event) => {
            if (this.pointerStartX === null) return;

            const distance =
              event.clientX - this.pointerStartX;

            this.pointerStartX = null;

            if (Math.abs(distance) < 40) return;

            if (distance > 0) {
              this.previous({
                announce: true,
                restart: true
              });
            } else {
              this.next({
                announce: true,
                restart: true
              });
            }
          },
          { signal: this.signal }
        );

        this.viewport?.addEventListener(
          'pointercancel',
          () => {
            this.pointerStartX = null;
          },
          { signal: this.signal }
        );

        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.hidden) {
              this.stopAutoplay();
            } else {
              this.startAutoplay();
            }
          },
          { signal: this.signal }
        );
      }

      normalizeIndex(index) {
        const count = this.slides.length;

        if (count === 0) return 0;

        if (this.loopEnabled) {
          return ((index % count) + count) % count;
        }

        return Math.min(
          Math.max(index, 0),
          count - 1
        );
      }

      showSlide(index, options = {}) {
        if (this.slides.length === 0) return;

        const {
          announce = false,
          restart = false
        } = options;

        this.currentIndex = this.normalizeIndex(index);

        this.slides.forEach((slide, slideIndex) => {
          const isActive =
            slideIndex === this.currentIndex;

          slide.classList.toggle(
            'is-active',
            isActive
          );

          slide.setAttribute(
            'aria-hidden',
            isActive ? 'false' : 'true'
          );

          slide.toggleAttribute('inert', !isActive);
        });

        this.dots?.forEach((dot, dotIndex) => {
          const isActive =
            dotIndex === this.currentIndex;

          dot.setAttribute(
            'aria-current',
            isActive ? 'true' : 'false'
          );
        });

        if (this.previousButton) {
          this.previousButton.disabled =
            !this.loopEnabled &&
            this.currentIndex === 0;
        }

        if (this.nextButton) {
          this.nextButton.disabled =
            !this.loopEnabled &&
            this.currentIndex ===
              this.slides.length - 1;
        }

        if (announce && this.status) {
          this.status.textContent =
            `Slide ${this.currentIndex + 1} of ` +
            `${this.slides.length}`;
        }

        if (restart) {
          this.restartAutoplay();
        }
      }

      previous(options = {}) {
        if (
          !this.loopEnabled &&
          this.currentIndex === 0
        ) {
          return;
        }

        this.showSlide(
          this.currentIndex - 1,
          options
        );
      }

      next(options = {}) {
        if (
          !this.loopEnabled &&
          this.currentIndex ===
            this.slides.length - 1
        ) {
          this.stopAutoplay();
          return;
        }

        this.showSlide(
          this.currentIndex + 1,
          options
        );
      }

      startAutoplay() {
        this.stopAutoplay();

        if (
          !this.autoplayEnabled ||
          this.slides.length <= 1 ||
          this.reducedMotion ||
          this.editorPaused ||
          document.hidden
        ) {
          return;
        }

        this.autoplayTimer = window.setInterval(
          () => {
            this.next({
              announce: false,
              restart: false
            });
          },
          this.autoplayDelay
        );
      }

      stopAutoplay() {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      selectEditorSlide(slide) {
        const index = this.slides.indexOf(slide);

        if (index < 0) return;

        this.editorPaused = true;
        this.stopAutoplay();

        this.showSlide(index, {
          announce: false,
          restart: false
        });
      }

      releaseEditorPause() {
        this.editorPaused = false;
        this.startAutoplay();
      }
    }

    customElements.define(
      elementName,
      VflImageSlider
    );

    document.addEventListener(
      'shopify:block:select',
      (event) => {
        const slide = event.target.closest?.(
          '[data-vfl-slide]'
        );

        if (!slide) return;

        const slider = slide.closest(elementName);

        slider?.selectEditorSlide(slide);
      }
    );

    document.addEventListener(
      'shopify:block:deselect',
      (event) => {
        const slide = event.target.closest?.(
          '[data-vfl-slide]'
        );

        if (!slide) return;

        const slider = slide.closest(elementName);

        slider?.releaseEditorPause();
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
